export default {
  type: {
    engagement: 'Motivación e implicación',
    representation: 'Representación de la información',
    actionAndExpression: 'Acción y expresión'
  },
  informationInDifferentFormats: 'Información en diferentes formatos',
  mediaForInteractionWithTheMaterial: 'Medios de la interacción con el material',
  optionsToCaptureInterest: 'Opciones para captar interés',
  supportElementsForDecoding: 'Elementos de apoyo para decodificar',
  variationOfResponses: 'Variación de respuestas',
  optionsToSustainEffortAndPersistence: 'Opciones para mantener esfuerzo y persistencia',
  optionsForComprehension: 'Opciones para la comprensión',
  developsExecutiveFunctions: 'Desarrolla funciones ejecutivas',
  optionsForSelfRegulation: 'Opciones para autorregulación'
}

export const en = {
  type: {
    engagement: 'Motivation and involvement',
    representation: 'Information representation',
    actionAndExpression: 'Action and expression'
  },
  informationInDifferentFormats: 'Information in different formats',
  mediaForInteractionWithTheMaterial: 'Media for interaction with the material',
  optionsToCaptureInterest: 'Options to capture interest',
  supportElementsForDecoding: 'Support elements for decoding',
  variationOfResponses: 'Variation of responses',
  optionsToSustainEffortAndPersistence: 'Options to sustain effort and persistence',
  optionsForComprehension: 'Options for comprehension',
  developsExecutiveFunctions: 'Develops executive functions',
  optionsForSelfRegulation: 'Options for self-regulation'
}

export const ca = {
  type: {
    engagement: 'Motivació i implicació',
    representation: 'Representació de la informació',
    actionAndExpression: 'Acció i expressió'
  },
  informationInDifferentFormats: 'Informació en diferents formats',
  mediaForInteractionWithTheMaterial: 'Mitjans de la interacció amb el material',
  optionsToCaptureInterest: 'Opcions per captar interès',
  supportElementsForDecoding: 'Elements de suport per a decodificar',
  variationOfResponses: 'Variació de respostes',
  optionsToSustainEffortAndPersistence: 'Opcions per mantenir esforç i persistència',
  optionsForComprehension: 'Opcions per a la comprensió',
  developsExecutiveFunctions: 'Desenvolupa funcions executives',
  optionsForSelfRegulation: 'Opcions per a l\'autoregulació'
}
